import { atom } from "recoil";

export const breadCrumbAtom = atom({
  key: "app-bar-breadcrumb",
  default: []
});
